// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal__Modal__cd320"};